// Vendor libraries
import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../directives/disabled/disabled.directive";
import * as i3 from "@angular/forms";
function SimpleModalFooterComponent_div_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "1 item selected");
} }
function SimpleModalFooterComponent_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.selectedItemCount, " items selected");
} }
function SimpleModalFooterComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 10)(2, "span", 11);
    i0.ɵɵtemplate(3, SimpleModalFooterComponent_div_1_ng_template_3_Template, 1, 0, "ng-template", 12)(4, SimpleModalFooterComponent_div_1_ng_template_4_Template, 1, 1, "ng-template", 13);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngPlural", ctx_r0.selectedItemCount);
} }
function SimpleModalFooterComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "button", 14);
    i0.ɵɵlistener("click", function SimpleModalFooterComponent_Conditional_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.deleteHandler.emit()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r0.deleteButtonText);
} }
function SimpleModalFooterComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "label", 15)(2, "input", 16);
    i0.ɵɵlistener("ngModelChange", function SimpleModalFooterComponent_div_3_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.checkboxHandler.emit($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 17)(4, "span", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r0.checkbox.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r0.checkbox.label);
} }
function SimpleModalFooterComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 19);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.errorText);
} }
function SimpleModalFooterComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 20);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.noteText);
} }
function SimpleModalFooterComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵlistener("click", function SimpleModalFooterComponent_div_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.cancelHandler.emit()); });
    i0.ɵɵtext(1, " Cancel ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.cancelButtonText);
} }
function SimpleModalFooterComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵlistener("click", function SimpleModalFooterComponent_div_9_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.secondaryHandler.emit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.disableSecondary)("textContent", ctx_r0.secondaryButtonText);
    i0.ɵɵattribute("data-test-id", ctx_r0.modalTestId ? ctx_r0.modalTestId + "-secondary-button" : ctx_r0.secondaryButtonText);
} }
function SimpleModalFooterComponent_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "div", 26);
    i0.ɵɵelementEnd();
} }
function SimpleModalFooterComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵlistener("click", function SimpleModalFooterComponent_div_10_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.submitHandler.emit()); });
    i0.ɵɵtemplate(1, SimpleModalFooterComponent_div_10_div_1_Template, 2, 0, "div", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.disableSubmission)("ngClass", ctx_r0.submitButtonClasses);
    i0.ɵɵattribute("data-test-id", ctx_r0.modalTestId ? ctx_r0.modalTestId + "-submit-button" : ctx_r0.submitButtonText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loading);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.submitButtonText, " ");
} }
/**
 *
 * Simple Modal Footer Component
 *
 * Input Properties:
 *  checkbox: optional object with a label and a value for a checkbox
 *  disableSubmission: Whether the submit button should be disabled or not. Defaults to false
 *  errorText: The text to display when there is an error
 *  noteText: The text to display as a note to the user
 *  selectedItemCount: How many items have been selected in this modal
 *  submitButtonText: The text that should be used for the submit button. Defaults to 'Submit'
 *  cancelButtonText: The text that should be used for the cancel button. Defaults to 'Cancel'
 *  deleteButtonText: The text that should be used for the delete button. If not provided, the delete button will not be shown
 *  showSubmitButton: Whether the submit button should be shown. Defaults to true
 *  showCancelButton: Whether the cancel button should be shown. Defaults to true
 *  modalTestId: A Unique Test id corresponding to the parent modal. Used to set the data-test-id attribute
 *               for the confirm and cancel buttons
 *
 * Output Properties:
 *  cancelHandler: emits when the user clicks Cancel
 *  checkboxHandler: emits the checkbox value when it changes
 *  submitHandler: emits when the user clicks Submit
 *  deleteHandler: emits when the user clicks Delete
 *
 */
export class SimpleModalFooterComponent {
    constructor() {
        this.showSubmitButton = true;
        this.showCancelButton = true;
        this.submitButtonClasses = 'btn-primary';
        this.cancelHandler = new EventEmitter();
        this.checkboxHandler = new EventEmitter();
        this.deleteHandler = new EventEmitter();
        this.secondaryHandler = new EventEmitter();
        this.submitHandler = new EventEmitter();
    }
    ngOnInit() {
        this.cancelButtonText = this.cancelButtonText || 'Cancel';
        this.submitButtonText = this.submitButtonText || 'Submit';
        this.disableSubmission = this.disableSubmission || false;
    }
}
SimpleModalFooterComponent.ɵfac = function SimpleModalFooterComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimpleModalFooterComponent)(); };
SimpleModalFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SimpleModalFooterComponent, selectors: [["ycn-simple-modal-footer"]], inputs: { checkbox: "checkbox", cancelButtonText: "cancelButtonText", disableSecondary: "disableSecondary", disableSubmission: "disableSubmission", errorText: "errorText", noteText: "noteText", deleteButtonText: "deleteButtonText", secondaryButtonText: "secondaryButtonText", selectedItemCount: "selectedItemCount", submitButtonText: "submitButtonText", showSubmitButton: "showSubmitButton", showCancelButton: "showCancelButton", modalTestId: "modalTestId", loading: "loading", submitButtonClasses: "submitButtonClasses" }, outputs: { cancelHandler: "cancelHandler", checkboxHandler: "checkboxHandler", deleteHandler: "deleteHandler", secondaryHandler: "secondaryHandler", submitHandler: "submitHandler" }, standalone: false, decls: 11, vars: 8, consts: [[1, "modal-footer", "user-select-none"], ["class", "modal-footer-info", 4, "ngIf"], [1, "modal-footer-info"], [1, "popupFooter"], ["class", "text-red", 3, "textContent", 4, "ngIf"], ["class", "modal-footer-info", 3, "textContent", 4, "ngIf"], [1, "modal-footer-actions"], ["class", "btn btn-text", 3, "textContent", "click", 4, "ngIf"], ["tabindex", "0", "class", "btn btn-primary", "ycnDisabled", "", 3, "disabled", "textContent", "click", 4, "ngIf"], ["tabindex", "0", "ycnDisabled", "", "class", "btn btn-primary", 3, "disabled", "ngClass", "click", 4, "ngIf"], [1, "list-metric-counter"], [3, "ngPlural"], ["ngPluralCase", "=1"], ["ngPluralCase", "other"], [1, "btn", "btn-outline", "btn-danger", 3, "click", "textContent"], [1, "custom-control", "custom-checkbox", "text-default"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"], [1, "text-red", 3, "textContent"], [1, "modal-footer-info", 3, "textContent"], [1, "btn", "btn-text", 3, "click", "textContent"], ["tabindex", "0", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled", "textContent"], ["tabindex", "0", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled", "ngClass"], ["class", "mr-1", 4, "ngIf"], [1, "mr-1"], [1, "loader-spinner-context", "loader-xs", "white"]], template: function SimpleModalFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SimpleModalFooterComponent_div_1_Template, 5, 1, "div", 1);
        i0.ɵɵconditionalCreate(2, SimpleModalFooterComponent_Conditional_2_Template, 2, 1, "div", 2);
        i0.ɵɵtemplate(3, SimpleModalFooterComponent_div_3_Template, 5, 2, "div", 1);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, SimpleModalFooterComponent_span_5_Template, 1, 1, "span", 4)(6, SimpleModalFooterComponent_span_6_Template, 1, 1, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, SimpleModalFooterComponent_div_8_Template, 2, 1, "div", 7)(9, SimpleModalFooterComponent_div_9_Template, 1, 3, "div", 8)(10, SimpleModalFooterComponent_div_10_Template, 3, 5, "div", 9);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selectedItemCount !== undefined && !ctx.errorText);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.deleteButtonText ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.checkbox);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.errorText);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.noteText && !ctx.errorText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showCancelButton);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.secondaryButtonText !== undefined);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showSubmitButton);
    } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgPlural, i1.NgPluralCase, i2.DisabledDirective, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel], encapsulation: 2 });
